import eventBus from 'toxilibs/event_bus_queued.js'
import random from 'toxilibs/random.js'
import globals from '../globals.js'
import Challenge from './challenge.js'
import Parkour from 'toxilibs/parkour.js'
import levelsStorage from '../persistence/levels_storage.js'
import '../progressions.js'

let tooLateCounter = 0

let questionsParkour

const parkour = new Parkour({
    synchronizer: levelsStorage,
    stepSignature: function (step) {
        return step.id
    },
    onStepReached: function (step) {
        questionsParkour  = parkour.current.questions
        eventBus.emit('level changed', step.id, parkour)
    },
    onStepCompleted: function (step) {
        eventBus.emit('level won', step.id, parkour)
        goToNextLevel()
    }
})







eventBus.on('levels loaded', function (levels) {
    parkour.add(levels)

    eventBus.emit('current state loaded', parkour.current.id, parkour)
})


eventBus.on('user wants to see all questions', launchWholeProgression)
eventBus.on('user wants to see logs', launchLogs)


eventBus.on('user wants to start', function () {

    if (parkour.current) {
        goToLevelAndLaunch(parkour.current.id)
    } else {
        console.warn('No current level')
    }

})


eventBus.on('player wants to reset save', function () {
    parkour.reset()
    eventBus.emit('parkour synchronizer reset')
})


function launchWholeProgression () {
    for (let i = 0; i < parkour.steps.length; i++) {
        const level = parkour.steps[i]
        for (let j = 0; j < level.questions.steps.length; j++) {
            const question = level.questions.steps[j]
            random.resetAllFairChoices()
            launchChallenge({
                levelID:    level.id,
                questionID: question.id,
                question
            })
        }
    }
}


function launchLogs () {
    if (typeof localStorage.log === 'undefined') {
        return
    }
    const log = JSON.parse(localStorage.log)  // TODO: get log in db

    for (let i = 0; i < log.history.length; i++) {
        const event = log.history[i]

        if (typeof event.question !== 'undefined') {
            random.resetAllFairChoices()
            const challenge = launchChallenge({
                levelID: event.level,
                questionID: event.question,
                question: findQuestion(event.level, event.question)
            })
            challenge.log_event = event
        }
    }
}


function findQuestion (levelId, questionID) {
    for (let i = 0; i < parkour.steps.length; i++) {
        const level = parkour.steps[i]
        if (level.id === levelId) {
            return level.questions.steps[questionID]
        }
    }
    return null
}


eventBus.on('user wants to go to level', goToLevelAndLaunch)

eventBus.on('user ready to start', function () {
    questionsParkour.goTo(0)
})

eventBus.on('question changed', function () {
    random.resetAllFairChoices()
    launchNewChallenge()
})

eventBus.on('questions parkour ended', function () {
    parkour.completeStep()
})







function goToLevelAndLaunch (newlevelID) {
    parkour.goTo(newlevelID)
    questionsParkour.goTo(0)
}


function goToNextLevel () {
    if (parkour.isLastStep()) {
        end()
    } else {
        parkour.goTo(parkour.next.id)
    }
}













function launchChallenge ({levelID, questionID, question}) {
    const challenge = new Challenge({
        levelID,
        questionID,
        question,
        callback:    endChallenge,
        noTimer:     (tooLateCounter >= 1),
        timeoutTime: question.timeoutTime //FIXME
    })

    globals.currentChallenge = challenge

    return challenge
}



function launchNewChallenge () {

    const currentQuestion = questionsParkour.current
    const questionID      = questionsParkour.currentSignature

    launchChallenge({
        levelID:  parkour.current.id,
        questionID,
        question: currentQuestion
    })

}


function launchNextChallenge (status) {
    if (status === 'win') {
        launchNextChallengeAfterWin()
    } else if (status === 'lose') {
        launchNextChallengeAfterLose()
    } else {
        relaunchChallenge()
    }
}


function relaunchChallenge () {
    launchNewChallenge()
}


function launchNextChallengeAfterWin () {
    const currentQuestion = questionsParkour.current
    if (questionsParkour.doneSteps[questionsParkour.currentSignature]) {
        if (questionsParkour.lowestNotDone) {
            const nextIndex = questionsParkour.getStepIndex(questionsParkour.lowestNotDone)
            questionsParkour.goTo(nextIndex)
        } else {
            questionsParkour.completeStep()
        }
    } else if (currentQuestion.times > 1) {
        currentQuestion.times -= 1
        relaunchChallenge()
    } else {
        questionsParkour.completeStep()
    }
}


function launchNextChallengeAfterLose () {
    const question   = questionsParkour.current
    const questionID = questionsParkour.currentSignature
    if (question.errorExpected) {
        question.errorExpected = false
        relaunchChallenge()
    } else {
        question.errors += 1
        question.times = Math.min(Math.max(3, question.initialTimes), question.times + 1)
        if (!question.dontGoBack && questionID > 0 && question.errors > 1) {
            questionsParkour.goTo(random.intBetween(Math.max(0, questionID - 2), questionID - 1))
        } else {
            relaunchChallenge()
        }
    }
}







function endChallenge (status) {
    eventBus.emit('challenge ended')

    updateTooLateCounter()

    emitChallengeResult(status)

    launchNextChallenge(status)

}


function emitChallengeResult (status) {
    if (status === 'win') {
        const level = parkour.current
        eventBus.emit('user won question', {
            levelID:           level.id,
            currentQuestionID: questionsParkour.currentSignature,
            errors:            questionsParkour.current.errors
        })
    } else if (status === 'lose') {
        eventBus.emit('user gave wrong answer')
    }
}







function updateTooLateCounter () {
    if (globals.currentChallenge && globals.currentChallenge.wasTooLate) {
        tooLateCounter += 1
    } else {
        tooLateCounter = 0
    }
}








function end () {
    globals.levelID = 'end' //FIXME
    eventBus.emit('end')
}


